// extracted by mini-css-extract-plugin
export default {"diffViewerStyle":"diffViewer_diffViewerStyle__8kcPg","diffViewerWidth":"diffViewer_diffViewerWidth__CoA67"};